import { FC, PropsWithChildren, useContext, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import LotContext, { ILotContext } from '../../contexts/data/LotContext';
import LotsContext from '../../contexts/data/LotsContext';


export interface ILotProviderProps {
}

export const LotProvider: FC<PropsWithChildren<ILotProviderProps>> = ({ children }) => {
    const lots = useContext(LotsContext);

    const lotId = Number(useParams()?.lotId);

    const lot  = useMemo(() => {
        if (!lotId) {
            return {
                data: lots.data && lots.data.length > 0 ? lots.data[0] : undefined,
                error: undefined,
                loading: false,
                validating: false,
                refresh: async () => {
                    return undefined;
                },
            } as ILotContext;
        }

        return {
            data: lots.data?.find(x => x.id === lotId),
            id: lotId,
            error: lots.error,
            loading: lots.loading,
            validating: lots.validating,
            refresh: async () => {
                const newData = await lots.refresh();

                return newData?.find(x => x.id === lotId);
            },
        } as ILotContext
    }, [lots, lotId]);

    return (

        <LotContext.Provider value={lot}>
            {children}
        </LotContext.Provider>
    );
}

export default LotProvider;
